import React from 'react'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect,
} from 'react-router-dom'
import useSWR from 'swr'
import { ModalProvider } from 'modaaals'
import Home from './Home'
import UserDetail from './UserDetail'
import RequestDetail from './RequestDetail'
import Templates from './Templates'
import AdminUsers from './AdminUsers'
import AdminUser from './AdminUser'
import Login from './Login'
import Layout from './Layout'
import { ChatModal, globalStyles } from './modals'
import storage, { getInitialData } from './storage'

import './App.css'

function App() {
  return (
    <Router>
      <ModalProvider
        modals={{ chat: ChatModal }}
        styles={globalStyles}
        drag={false}
        motionProps={{
          animate: { translateX: 0 },
          initial: { translateX: '100%' },
        }}
      >
        <Layout>
          <Switch>
            <PrivateRoute exact path="/">
              <Home />
            </PrivateRoute>

            <PrivateRoute exact path="/adminusers" superadmin>
              <AdminUsers />
            </PrivateRoute>

            <PrivateRoute exact path="/adminuser/:id" superadmin>
              <AdminUser />
            </PrivateRoute>

            <PrivateRoute exact path="/user/:userId/quote/:id">
              <RequestDetail requestType="quote" />
            </PrivateRoute>

            <PrivateRoute exact path="/user/:userId/supervision/:id">
              <RequestDetail requestType="supervision" />
            </PrivateRoute>

            <PrivateRoute exact path="/user/:userId/purchased/:id">
              <RequestDetail requestType="purchased" />
            </PrivateRoute>

            <PrivateRoute path="/user/:userId">
              <UserDetail />
            </PrivateRoute>

            <PrivateRoute path="/templates">
              <Templates />
            </PrivateRoute>

            <Route exact path="/login">
              <Login />
            </Route>
          </Switch>
        </Layout>
      </ModalProvider>
    </Router>
  )
}

export default App

const PrivateRoute = ({ children, superadmin, ...rest }) => {
  const { data: profile } = useSWR('pxmusic_admin', storage, {
    refreshInterval: 1000,
    initialData: getInitialData('pxmusic_admin'),
    revalidateOnMount: true,
  })

  return (
    <Route
      {...rest}
      render={({ location }) =>
        profile && profile.token ? (
          superadmin ? (
            profile.superAdmin ? (
              children
            ) : (
              <div className="home-grid">
                <h1 className="home-title" style={{ marginBottom: '1.3em' }}>
                  Not Authorized <Link to="/">Back Home</Link>
                </h1>
              </div>
            )
          ) : (
            children
          )
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: location },
            }}
          />
        )
      }
    />
  )
}
